/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow, FlexCol, TextField } from 'sarsaparilla';
import {
    IS_EC_FIRSTNAME_EMPTY,
    IS_EC_LASTNAME_EMPTY,
    IS_EC_PHONE_EMPTY,
} from '../../constants';
import { getValidationErrorStyle } from '../../utils/utilsNew';

export default class EmergencyContact extends React.Component {
    static propTypes = {
        handleEmergencyContactChange: PropTypes.func,
        contact: PropTypes.shape({
            first_name: PropTypes.string,
            last_name: PropTypes.string,
            phone: PropTypes.string,
        }),
        validation: PropTypes.shape({
            [IS_EC_FIRSTNAME_EMPTY]: PropTypes.element,
            [IS_EC_LASTNAME_EMPTY]: PropTypes.element,
            [IS_EC_PHONE_EMPTY]: PropTypes.element,
        }),
        validationRequired: PropTypes.shape({
            [IS_EC_FIRSTNAME_EMPTY]: PropTypes.string,
            [IS_EC_LASTNAME_EMPTY]: PropTypes.string,
            [IS_EC_PHONE_EMPTY]: PropTypes.string,
        }),
        hasOptionalFields: PropTypes.bool,
    };

    static defaultProps = {
        contact: {
            first_name: '',
            last_name: '',
            phone: '',
        },
        validation: {},
        validationRequired: {},
        hasOptionalFields: false,
    };

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const contactObj = { ...this.props.contact };
        switch (event.target.id) {
            case 'emergency-contact-firstname':
                contactObj.first_name = event.target.value;
                break;
            case 'emergency-contact-lastname':
                contactObj.last_name = event.target.value;
                break;
            case 'emergency-contact-phone-num':
                contactObj.phone = event.target.value;
                break;
            default:
                return;
        }
        this.props.handleEmergencyContactChange(contactObj);
    }

    render() {
        const { contact, validation, validationRequired } = this.props;
        const firstNameValidationClass = getValidationErrorStyle(
            validation,
            IS_EC_FIRSTNAME_EMPTY
        );
        const lastNameValidationClass = getValidationErrorStyle(
            validation,
            IS_EC_LASTNAME_EMPTY
        );
        const phoneNumValidationClass = getValidationErrorStyle(
            validation,
            IS_EC_PHONE_EMPTY
        );
        return (
            <div
                data-testid="emergency-contact"
                className="per-emergency-form per-section-group"
            >
                <div className="rec-order-detail-subsection-title">Emergency Contact</div>
                <p>
                    Please provide the contact info for a person not attending your trip
                    that can be reached in the event of a facility-wide emergency.
                </p>
                <FlexRow>
                    <FlexCol md={4}>
                        <div className="rec-form-item-wrap">
                            <TextField
                                isRequired={
                                    !this.props.hasOptionalFields &&
                                    !!validationRequired[IS_EC_FIRSTNAME_EMPTY]
                                }
                                label="First Name"
                                value={contact.first_name}
                                onChange={this.handleChange}
                                isInvalid={
                                    !this.props.hasOptionalFields &&
                                    !!firstNameValidationClass
                                }
                                id="emergency-contact-firstname"
                            />
                        </div>
                    </FlexCol>
                    <FlexCol md={4}>
                        <div className="rec-form-item-wrap">
                            <TextField
                                isRequired={
                                    !this.props.hasOptionalFields &&
                                    !!validationRequired[IS_EC_LASTNAME_EMPTY]
                                }
                                label="Last Name"
                                value={contact.last_name}
                                onChange={this.handleChange}
                                isInvalid={
                                    !this.props.hasOptionalFields &&
                                    !!lastNameValidationClass
                                }
                                id="emergency-contact-lastname"
                            />
                        </div>
                    </FlexCol>
                    <FlexCol md={4}>
                        <div className="rec-form-item-wrap">
                            <TextField
                                isRequired={
                                    !this.props.hasOptionalFields &&
                                    !!validationRequired[IS_EC_PHONE_EMPTY]
                                }
                                label="Phone Number"
                                value={contact.phone}
                                onChange={this.handleChange}
                                isInvalid={
                                    !this.props.hasOptionalFields &&
                                    !!phoneNumValidationClass
                                }
                                id="emergency-contact-phone-num"
                            />
                        </div>
                    </FlexCol>
                </FlexRow>
            </div>
        );
    }
}
